import "../css/Popups.css";
import "./ProjectsStyle.css";

function Projects({onClose}){
    return(
        <div className="shade">
            <section id="project-popup">
                <div className="top">
                    <h1>Projects</h1>
                    <button onClick={onClose} className="closeBtn">X</button>
                </div>

                <div className="mid">
                    
                    <div>
                        <h2>Latest Projects</h2>

                        <div className="project-card-container">
                            <h3>I will be uploading projects soon</h3>
                            {/* <div className="project-card">
                                <img src={require("./project1.jpg")} />
                            </div>

                            <div className="project-card">
                                <img src={require("./project1.jpg")} />
                            </div>


                            <div className="project-card">
                                <img src={require("./project1.jpg")} />
                            </div>


                            <div className="project-card">
                                <img src={require("./project1.jpg")} />
                            </div>

                            <div className="project-card">
                                <img src={require("./project1.jpg")} />
                            </div>


                            <div className="project-card">
                                <img src={require("./project1.jpg")} />
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="bottom">
                    <img src={require("../images/about-bottom.png")} alt="" width="100%" height="50px" />
                </div>
            </section>
        </div>

    )
}
 export default Projects;